import { combineReducers, configureStore } from "@reduxjs/toolkit";
import * as Sentry from "@sentry/react";
import { getPreloadedState, saveToLocalStorage } from "./localStorage";
import sidebarSlice from "./sidebarSlice";
import commonSlice from "./commonSlice";
import languageSlice from "./languageSlice";
import mobilemenuSlice from "./mobileheaderSlice";
import messagesSlice from "./messagesSlice";
import { initVideoUploadSync } from "../../utils/videoUploadSync";
const combinedReducer = combineReducers({
  sidebar: sidebarSlice,
  common: commonSlice,
  language: languageSlice,
  mobilemenu: mobilemenuSlice,
  messages: messagesSlice,
});

const rootReducer = (state: any, action: any) => {
  if (action.type === "login/logout") {
    state = undefined;
  }

  return combinedReducer(state, action);
};

const sentryReduxEnhancer = Sentry.createReduxEnhancer();

const store = configureStore({
  reducer: rootReducer,
  preloadedState: getPreloadedState(),
  enhancers: (getDefaultEnhancers) => getDefaultEnhancers().concat(sentryReduxEnhancer),
  // devTools: true
});

function onStateChange() {
  saveToLocalStorage(store.getState());
}

store.subscribe(onStateChange);
initVideoUploadSync(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
